export const SESSION_KEY = {
  SESSION: 'session',
}
